import { css } from '@emotion/css';
import {
  m,
  mobileMediaQuery,
  nonMobileMediaQuery,
  Spacing,
} from '@snapchat/snap-design-system-marketing';

import { totalHeaderHeightCssVar } from '../../../../components/Header/headerSizeUtils';

const isolatedStreamReplayClass = 'isolated';

export const videoPreviewClass = 'video-preview';
export const learnMoreClass = 'learn-more';
export const blurbClass = 'blurb';
export const blurbWithLogoClass = 'blurb-with-logo';

export const streamReplayContainerCss = css`
  position: relative;
  min-height: 510px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  ${mobileMediaQuery} {
    height: calc(100vh - var(${totalHeaderHeightCssVar}));
    height: calc(100dvh - var(${totalHeaderHeightCssVar}));
    max-height: unset;
  }

  /* Overrides for isolated layout */
  &.${isolatedStreamReplayClass} {
    height: unset;
    max-height: unset;
    min-height: calc(100vh - var(${totalHeaderHeightCssVar}));

    ${mobileMediaQuery} {
      align-items: start;
    }
  }
`;

export const streamReplayInnerWrapperCss = css`
  width: 90%;
  max-width: 1150px;
  display: flex;
  flex-direction: column;

  p {
    font-size: 16px;
    line-height: 26px;

    /* Ensure blurb renders above the animation */
    position: relative;
    z-index: 1;
  }

  .${learnMoreClass} {
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
  }

  .blurb {
    margin-top: 20px;
  }

  ${nonMobileMediaQuery} {
    flex-direction: row;

    .${blurbClass} {
      display: none;
    }

    /* Change flex order here so that animation appears above the video
    thumbnail on mobile */
    .${blurbWithLogoClass} {
      order: 1;
      padding-left: 60px;
    }

    .${videoPreviewClass}, .${blurbWithLogoClass} {
      flex-basis: 50%;
      flex-grow: 0;
    }

    .${learnMoreClass} {
      display: none;
    }

    .${videoPreviewClass} {
      height: unset;
      margin-top: 0;
    }
  }

  ${mobileMediaQuery} {
    margin-bottom: var(${totalHeaderHeightCssVar});

    .${blurbClass}, .${blurbWithLogoClass} {
      display: none;
    }
  }

  /* Overrides for isolated layout */
  &.${isolatedStreamReplayClass} {
    .${learnMoreClass} {
      display: none;
    }

    ${mobileMediaQuery} {
      margin-top: 40px;

      .${blurbWithLogoClass} {
        /* On mobile, animation should show above the video thumbnail */
        order: -1;
        width: 100%;

        /* Hide text part of this content on mobile. The text will instead be displayed
        inside the stand alone .blurb element just below the thumbnail */
        p {
          display: none;
        }
      }

      .${blurbClass}, .${blurbWithLogoClass} {
        display: block;
      }
    }
  }
`;

export const logoCss = css`
  max-width: 400px;
  width: 100%;
  margin-bottom: 20px;
`;

export const highlightsSectionCss = css`
  margin: 0 auto;
  padding-bottom: ${Spacing['4XL']}px;
  padding-left: ${Spacing.LG}px;
  padding-right: ${Spacing.LG}px;

  ${nonMobileMediaQuery} {
    max-width: 1130px;
    width: 90%;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const highlightsTitleCss = css`
  text-align: center;
  margin: 1em 0;
`;

export const blurbCss = css`
  color: ${m('--fg-color')};
`;
